<template>
  <div class="sai-tag-category">
    <div class="search_title">カテゴリ</div>
    <ul class="search_btn cf">
      <li class="search_btns upper search_btn_text2" @click.prevent="selectRegion('キャンペーン・特典')">
        <img src="../resource/sai-icon_campaign.png" alt="キャンペーン・特典" />
        <div class="text">キャンペーン・<br class="spbr" />特典</div>
      </li>
      <li class="search_btns upper" @click.prevent="selectRegion('商品・ご注文')">
        <img src="../resource/sai-icon_product.png" alt="商品・ご注文" />
        <div class="text">商品・ご注文</div>
      </li>
      <li class="search_btns upper" @click.prevent="selectRegion('お支払方法')">
        <img src="../resource/sai-icon_payment.png" alt="お支払方法" />
        <div class="text">お支払方法</div>
      </li>
      <li class="search_btns upper" @click.prevent="selectRegion('配送・お届け')">
        <img src="../resource/sai-icon_deliver.png" alt="配送・お届け" />
        <div class="text">配送・お届け</div>
      </li>
      <li class="search_btns bottom" @click.prevent="selectRegion('交換・返品・修理')">
        <div class="text">交換・返品・修理</div>
      </li>
      <li class="search_btns bottom" @click.prevent="selectRegion('会員情報')">
        <div class="text">会員情報</div>
      </li>
      <li class="search_btns bottom search_btn_text2" @click.prevent="selectRegion('メールマガジン・カタログ')">
        <div class="text">メールマガジン・<br class="spbr" />カタログ</div>
      </li>
      <li class="search_btns bottom search_btn_text2" @click.prevent="selectRegion('家具レンタル(フレクト)')">
        <div class="text">家具レンタル<br class="spbr" />(フレクト)</div>
      </li>
    </ul>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import { eventBus } from '@/eventBus';
import TagCategoryMixin from '@/mixins/TagCategoryMixin';
import Const from '../const/index';

@Component({})
export default class TagCategory extends mixins(TagCategoryMixin) {
  popularTagTitle = Const.POPULAR_TAG_TITLE;

  async selectRegion(tagText) {
    const tags = await this.$store.dispatch('tagSearch/tagifyTextExact', tagText);
    this.$emit('setShow', true);
    if (!this.$store.state.user.isIphone) {
      eventBus.$emit('selectNextTag');
    }

    if (this.$store.state.user.isSP && !this.$store.state.user.isIphone) {
      setTimeout(() => {
        eventBus.$emit('scrollToTop');
      }, 300);
    }

    if (this.$store.state.ticket.resetFlag) {
      eventBus.$emit('resetTicket');
      return;
    }
    const newTicket = await this.updateTicket(tags);
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
}
</script>

<style lang="scss" scoped>
@import '../style/setting/variable';

.sai-tag-category {
  width: 100%;
  background-color: #eee;
  padding: 0 9px 9px 3px;

  .search_title {
    font-size: 13px;
    color: #757575;
    padding-bottom: 6px;
    .mobile & {
      font-size: 12px;
    }
  }

  .search_btn {
    list-style: none;
    width: 100%;

    &.cf::after {
      content: '';
      display: block;
      clear: both;
    }

    li {
      border: 2px solid #ddd;
      padding: 12px 8px;
      margin: 0 10px 10px 0 !important;
      position: relative;
      width: calc(25% - 10px);
      float: left;
      font-size: 14px;
      background-color: #fff;
      border-radius: 6px;
      cursor: pointer;

      .text {
        display: block;
        font-size: 14px;
        font-family: $subFontFamily;
        font-weight: 700;
        color: #000;
        text-align: center;
      }

      &:hover {
        background: #c5fd5d;
      }
    }

    .search_btns {
      display: flex;
      align-items: center;
      justify-content: space-around;

      &.upper {
        text-align: left;
        height: 93px;

        .text {
        }
        img {
          width: 95px;
          opacity: 1 !important;
          transition: none !important;
        }
      }

      &.bottom {
        height: 63px;
        .text {
          .spbr {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .sai-tag-category {
    .search_btn {
      li {
        width: calc(50% - 10px);
      }
      .search_btns {
        &.upper {
          height: 95px;
          flex-direction: column;
          .text {
            padding-top: 2px;
            .spbr {
              display: none;
            }
          }
          img {
            width: 80px;
          }
        }
        &.bottom {
          .text {
            .spbr {
              display: block;
            }
          }
        }
      }
      .search_btn_text2 {
      }
    }
  }
}

@media screen and (max-width: 340px) {
  .sai-tag-category {
    .search_btn {
      .search_btns {
        .text {
          line-height: 1.3em;
          font-size: 13px;
        }
        &.upper {
          height: 95px;
          flex-direction: column;
          .text {
            .spbr {
              display: none;
            }
          }
          img {
            width: 70px;
          }
        }
        &.bottom {
          .text {
            .spbr {
              display: block;
            }
          }
        }
      }
      .search_btn_text2 {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/TagCategory.vue